/* eslint no-underscore-dangle: 0 */
/* eslint import/no-extraneous-dependencies: 0 */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { toPng } from 'html-to-image';
import { setErrorNotification } from '../../../../redux/slices/NotificationSlice';
import ModalBox from '../../../../shared/component/ModalBox';
import TemplateContentUpload from '../TemplateContentUpload';
import HtmlHeader from '../HtmlHeader';
import utils from '../templateFunctions';
import FileFormat from '../FileFormat';
import { createOrUpdateTemplate } from '../../../../redux/slices/TemplateSlice';
import PopupBox from '../ContentUploadConfirmation';

function HtmlTemplateTwentyFive({ templateData }) {
  const [data, setData] = useState([]);
  const [notification, setNotification] = useState(false);
  const [openContentUploadConfirmation, setOpenContentUploadConfirmation] = useState(false);
  const [base64, setBase64] = useState('');
  const [htmlContent, setHtmlContent] = useState('');
  const [disable, setDisable] = useState(true);
  const [modalView, setModalView] = useState({ content: '', title: '' });
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const htmlRef = useRef(null);
  const convertBase64Ref = useRef(null);
  const convertHtmlRef = useRef(null);

  const cssStyles = `
    body {
      margin: 0;
      padding: 0;
    }
    .jewellery-card {
      position: relative;
      font-family: "Montserrat", sans-serif;
      box-sizing: border-box;
      overflow: hidden;
    }
    .jewellery-card__header {
      width: 100%;
      display: flex;
      align-items: center;
    }
    .jewellery-card__header p {
      letter-spacing: 4px;
      color: #84572E;
      margin-inline: 10px;
      white-space: nowrap;
    }
    .jewellery-card__header::after {
      content: "";
      width: 100%;
      height: 1px;
      background-color: #84572E;
    }
    .jewellery-card--footer {
      flex-direction: row-reverse;
    }
    .jewellery-card--footer::after {
      width: 50%;
    }
    .jewellery-card .main-container {
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 50px;
    }
    .jewellery-card__content {
      display: flex;
      justify-content: space-evenly;
      width: 100%;
      margin-block: 71px;
    }
    .jewellery-card__image {
      border-radius: 50%;
      width: 40%;
      position: relative;
      z-index: 1;
    }
    .jewellery-card__image::before {
      content: "";
      width: 100%;
      height: 100%;
      top: 50%;
      inset-inline-end: 50%;
      position: absolute;
      z-index: -1;
      background-color: #FAEADC;
    }
    .jewellery-card__image img {
      width: 100%;
      height: 100%;
    }
    .jewellery-card .detils-jewellery {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      padding-block: 30px;
      width: 50%;
      text-align: center;
    }
    .jewellery-card .detils-jewellery__title {
      font-family: "TAN - PEARL";
      font-weight: 400;
      font-size: 120px;
      color: #A47B55;
    }
    .jewellery-card .detils-jewellery__offer {
      font-size: 24px;
      font-weight: 400;
      border: 0;
      outline: none;
      cursor: pointer;
      padding: 10px 40px;
      color: #FFF;
      background-color: #A47B55;
    }
    .jewellery-card .detils-jewellery__desc {
      color: #84572E;
      font-size: 32px;
      font-weight: 400;
      text-align: start;
    }
    @media (max-width: 991px) {
      .jewellery-card--footer::after {
        width: 100%;
      }
      .jewellery-card__content {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 30px;
      }
      .jewellery-card__image {
        width: 70%;
      }
      .jewellery-card__image::before {
        width: 100%;
        height: 60%;
      }
      .jewellery-card .detils-jewellery {
        width: 100%;
      }
      .jewellery-card .detils-jewellery__title {
        font-size: 90px;
      }
      .jewellery-card .detils-jewellery__desc {
        font-size: 20px;
      }
    }
  `;

  const convertImage = async (url) => {
    await utils.convertSignedUrl(url)
      .then((response) => {
        setDisable(false);
        dispatch(createOrUpdateTemplate(response));
      })
      .catch((error) => {
        setDisable(false);
        dispatch(setErrorNotification(error?.response?.data));
      });
  };

  // const convertBase64 = async () => {
  //   toPng(htmlRef?.current, { cacheBust: true })
  //     .then((dataUrl) => {
  //       setBase64(dataUrl);
  //       convertImage(dataUrl);
  //     })
  //     .catch((error) => {
  //       dispatch(setErrorNotification(error?.response?.data));
  //     });
  // };

  convertBase64Ref.current = async () => {
    toPng(htmlRef?.current, { cacheBust: true })
      .then((dataUrl) => {
        setBase64(dataUrl);
        convertImage(dataUrl);
      })
      .catch((error) => {
        dispatch(setErrorNotification(error?.response?.data));
      });
  };

  convertHtmlRef.current = () => {
    if (htmlRef.current) {
      const content = htmlRef.current.outerHTML;
      const fullHtml = `
        <html>
          <head>
              <link rel="preconnect" href="https://fonts.googleapis.com" />
              <link rel="preconnect" href="https://fonts.gstatic.com" />
              <link 
              href="https://fonts.googleapis.com/css2?family=Great+Vibes&family=Urbanist:wght@100..900&display=swap" 
              rel="stylesheet" />
              <style>${cssStyles}</style>
          </head>
          <body>${content}</body>
        </html>
      `;
      setHtmlContent(fullHtml); // Set the HTML content as a string
    }
  };

  useEffect(() => {
    utils?.initializer(templateData).then((res) => (setData(res)));
    utils?.reload();
  }, [templateData]);

  /* useEffect runs convertBase64 after data is updated */
  useEffect(() => {
    if (data?.length > 0 && data?.[0]?.template_contents?.items?.length > 0) {
      setTimeout(() => {
        convertBase64Ref.current?.();
      }, 1500);
      convertHtmlRef.current?.();
    }
  }, [data]);

  const handleFileType = (fileType) => {
    setModalView({
      title: 'content',
      content: <TemplateContentUpload
        base64={base64}
        setNotification={setNotification}
        fileType={fileType}
        htmlContent={htmlContent}
      />,
    });
  };

  const onClickContentUpload = () => {
    setNotification(true);
    setModalView({
      title: t('fileFormat'),
      content: <FileFormat
        setNotification={setNotification}
        handleFileType={handleFileType}
        setOpenContentUploadConfirmation={setOpenContentUploadConfirmation}
        data={data}
      />,
    });
  };

  const contentDetails = data?.[0]?.template_contents?.items?.[0]?.details;
  const backgroundColor = data?.[0]?.styles?.background;

  return (
    <div>
      <HtmlHeader
        htmlData={data}
        disable={disable}
        click={onClickContentUpload}
      />

      <ModalBox
        status={notification}
        closeModal={setNotification}
        modalView={modalView}
      />

      <ModalBox
        status={openContentUploadConfirmation}
        closeModal={setOpenContentUploadConfirmation}
        modalView={{
          title: 'Confirmation',
          content: <PopupBox
            setOpenContentUploadConfirmation={setOpenContentUploadConfirmation}
            setNotification={setNotification}
          />,
        }}
      />

      <div className="header-height" />

      <div ref={htmlRef} className="jewellery-card">

        <div style={{ backgroundColor: `${backgroundColor}` }} className="main-container">
          <div className="jewellery-card__header">
            <p>{contentDetails?.[0]?.header?.toUpperCase()}</p>
          </div>

          <div className="jewellery-card__content">
            <div className="jewellery-card__image">
              <img src={contentDetails?.[0]?.image} alt="Template Pic" />
              <span> </span>
            </div>

            <div className="detils-jewellery">
              <h1 className="detils-jewellery__title">{contentDetails?.[0]?.item_name?.toUpperCase()}</h1>

              <button type="button" className="detils-jewellery__offer">
                UP TO {contentDetails?.[0]?.offer_percentage?.toUpperCase()} OFF
              </button>

              <p className="detils-jewellery__desc">{contentDetails?.[0]?.description}</p>
            </div>
          </div>

          <div className="jewellery-card__header jewellery-card--footer">
            <p>{contentDetails?.[0]?.website}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

HtmlTemplateTwentyFive.propTypes = {
  templateData:
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      template_title: PropTypes.string.isRequired,
    }).isRequired,
  // Ensure templateData is an array of objects with specific shape
};

export default HtmlTemplateTwentyFive;
